export default "__VITE_ASSET__BGHXI559__"